<template>
  <div :class="classes">
    <pt-page-title
      title="通知消息"
      :isSearch="false"
      @search="search"
      @emptySearch="emptySearch"
      :keyword="searchKey"
    >
      <template slot="before-left">
        <el-button type="primary" @click="readAll">全部已读</el-button>
      </template>
    </pt-page-title>
    <reservation-notifications-table
      ref="table"
      :class="$style['pt-hospital-table']"
    >
    </reservation-notifications-table>
  </div>
</template>
<script>
import { emptyObject } from "utils/lifebankUtils";

const prefixCls = "reservation-notifications";
import reservationNotificationsTable from "../reservation-notifications-table/withData.vue";

export default {
  name: "reservation-notifications",
  computed: {
    classes() {
      return `${prefixCls}`;
    }
  },
  components: {
    reservationNotificationsTable
  },
  data() {
    return {
      searchKey: "",
      params: {},
    };
  },
  methods: {
    readAll() {
      this.$confirm("确定已读全部通知？", "取消提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("setAllNotificationsIsRead")
          .then(() => {
            this.$message.success("全部已读");
            this.getTableData();
          })
          .catch(err => {
            this.$message.error(err || "全部已读失败");
          });
      });
    },
    search(val) {
      this.searchKey = val;
      emptyObject(this.params);
      this.$set(this.params, "searchKey", val);
      this.getTableData();
    },
    emptySearch() {
      this.$delete(this.params, "searchKey");
    },
    getTableData() {
      this.$refs.table.getTableData();
    },
    goDetail(row) {
      this.$router.push("/reservation-detail/" + row.id);
    }
  }
};
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-hospital-table {
  :global .iconfont {
    margin-right: 10px;
  }
}
.download-qrcode {
  color: #edbe81;
}
</style>
